import { DialogBody } from "shared/components/Spor";
import { ObtrusiveScrollCss } from "shared/components/transitions/scroll";
import styled, { css } from "styled-components";

export const ScrollableDialogBody = styled(DialogBody)<{
  $hideScrollbar?: boolean;
  $noOverflow?: boolean;
}>`
  ${ObtrusiveScrollCss};

  ${({ $noOverflow }) => !$noOverflow && `overflow-y: auto;`}
  max-height: 65vh;

  ${({ $hideScrollbar }) =>
    $hideScrollbar &&
    css`
      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    `}
`;
